export const BUSINESS_DATE_URL = "/api/core/business_date"
export const NUM_ADVANCERS_RETREATERS_URL = "/api/core/num_advancers_retreaters"
export const ADVANCERS_RETREATERS_URL = "/api/core/advancers_retreaters"
export const TOP_MOVERS_URL = "/api/core/top_movers"
export const FUNDAMENTALS_URL = "/api/company_details/fundamentals/%s"
export const MAGIC_URL = "/api/magic"
export const MAGIC_HISTORICAL_URL = "/api/magic/%s"
export const GROWTH_ANNUAL_URL = "/api/growth/annual/%s/%s"
export const CONTACT_URL = "/api/core/contact"